/**
 *主体及运营信息
 * 2018-3-9
 * geyuankai
 */
"use strict";
angular.module("mainOperationInfoModule", ["changeMainOperInfoModule"]).
controller("mainOperationInfoCtrl", ["$scope", "$q", "$element", "$validation", "httpService", "modalDialog","Upload","$state", function($scope, $q, $element, $validation, httpService, modalDialog,Upload,$state) {
    initStatus();
    initData();
    function initStatus() {
        $scope.data = {
        	
        };
        $scope.status = {
        	auditStatus:'',
        	mediaType:["个人","媒体","国家机构","企业","其他组织"],
        };
        $scope.photoCard = "";
    }

    function initData() {
    	requestData();
    }
    /**
     * [requestData description] 初始化用户信息
     */
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/user/getLoginUser.do", "", "get").then(function(data) {
        	$scope.status.auditStatus = data.auditStatus;
            $scope.info = data.loginUser;
            $scope.photoCard = data.loginUser.idNumberPic;
            $scope.idNumberPic = data.loginUser.idNumberPic;
            $scope.status.photoCard = data.loginUser.idNumberPic;
            $scope.data.city = data.loginUser.city;
            $scope.data.province = data.loginUser.province;
        });
    };
    /**
     * [changeidNumberPic description]  更换身份证
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.changeidNumberPic = function(files, file, newFiles, item) {
        //不能是gif
        var typeData = file.type.split('/')[1];
        if (typeData != 'jpg' && typeData != 'jpeg' && typeData != 'png') {
            modalDialog.success("您只能上传jpg,jpeg,png类型的文件", "success", false, function() {}, function() {}, '', 'notice');
            return;
        }
        if (!file) return;
        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            return;
        }
        if (newFiles) {
            $scope.status.changeHeader = true;
        }
        Upload.upload({
            url: "/mcnww/upload/image.do",
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: {
                file: newFiles[0]
            },
        }).then(function(resp) {
            if (!resp.data.success) {
                modalDialog.success(resp.data.message, "success", false, function() {});
                return;
            }
            var time = new Date().getTime();
            var successInfo;
            $scope.photoCard = angular.globalConfig.pictureServer + resp.data.url + '?' + time;
            $scope.idNumberPic = resp.data.url;
//          successInfo = "身份证照片上传成功";
//          modalDialog.success(successInfo, "success", false, function() {});
        });
    };
    /**
     * [savePwd description] 保存修改
     * @return {[type]} [description]
     */
    $scope.save = function() {
        $validation.validate($scope.modifyInfoForm).success(function() {
            var params = {
                truename: $scope.info.truename,
                email: $scope.info.email,
                idNumber: $scope.info.idNumber,
                idNumberPic: $scope.idNumberPic,
                province: $scope.data.province,
                city: $scope.data.city
            };
            modalDialog.confirmModal("提交修改", "提交修改后，该帐号需要重新审核。在审核期间，APP帐号信息显示不变", function() {
                sendtoService(params);
            });
        }).error(function() {
            angular.invalidPosition($scope.modifyInfoForm, $element);
        });

        function sendtoService(params) {
            httpService.http("/mcnww/web/ucenter/pgcUpdateOperInfo.do", params, "post", true, true).then(function(result) {
                if (result.success) {
                    modalDialog.success("内容修改成功", "success", false, function() {});
                    $scope.$root.$broadcast("pgcSucessLogo", true);
                    $state.go($state.current.name, "", { reload: $state.current.name });
                }else{
                    modalDialog.success(result.message, "success", false,function() {}, function() {},'','everyMonth');
                }

            });
        }
    };
}]);